export const STRIPE_CHECKOUT_SESSION_KEY = "qnb_stripe_checkout_session";

export function saveStripeCheckoutSessionId(sessionId: string) {
  if (!sessionId) return;
  try {
    sessionStorage.setItem(STRIPE_CHECKOUT_SESSION_KEY, sessionId);
  } catch {
    /* ignore storage errors */
  }
}

export function peekStripeCheckoutSessionId(): string | null {
  try {
    return sessionStorage.getItem(STRIPE_CHECKOUT_SESSION_KEY);
  } catch {
    return null;
  }
}

export function consumeStripeCheckoutSessionId(): string | null {
  try {
    const id = sessionStorage.getItem(STRIPE_CHECKOUT_SESSION_KEY);
    sessionStorage.removeItem(STRIPE_CHECKOUT_SESSION_KEY);
    return id;
  } catch {
    return null;
  }
}

export function clearStripeCheckoutSessionId() {
  try {
    sessionStorage.removeItem(STRIPE_CHECKOUT_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/** Stripe success URL uses `?success={CHECKOUT_SESSION_ID}`. */
export function getStripeSessionIdFromSearch(search: string): string | null {
  const params = new URLSearchParams(search);
  return params.get("success") || params.get("session_id") || null;
}
